export enum GridScrollDirection {
  Left = 'left',
  Right = 'right',
}
